export enum ChatNoteFormFieldsNames {
  Note = 'note',
}

export interface ChatNoteFormFields {
  [ChatNoteFormFieldsNames.Note]?: string;
}
